import { IngredientKind } from '@sg/graphql-schema';

import {
  type GroupedModifierItem,
  type ModifierItem,
} from '../useLineItemModifierIngredients.types';

// ─────────────────────────────────────────────────────────────────────────────

export function groupByName(items: ModifierItem[]): GroupedModifierItem[] {
  const map = items.reduce((acc, item) => {
    const key = item.name.toLowerCase();
    const existing = acc.get(key);

    if (existing) {
      existing.count += 1;
      existing.cost += item.cost;

      return acc;
    }

    acc.set(key, { name: item.name, count: 1, cost: item.cost, kind: item.kind });

    return acc;
  }, new Map<string, GroupedModifierItem>());

  return [...map.values()].sort(sortByIngredientKind);
}

export function sortByIngredientKind(item: ModifierItem, nextItem: ModifierItem) {
  return getKindOrder(item.kind) - getKindOrder(nextItem.kind);
}

function getKindOrder(kind: IngredientKind | null) {
  switch (kind) {
    case IngredientKind.Base:
      return 0;
    case IngredientKind.Premium:
      return 1;
    case IngredientKind.Dressing:
      return 2;
    case IngredientKind.Topping:
      return 3;
    default:
      return 4;
  }
}
